(function() {
  var __cfg = window.__spxCfg_swWishlist || {};
  var SW_LOGGED_IN = !!__cfg.loggedIn;
  var SW_CUSTOMER_ID = __cfg.customerId || 0;
  var SW_STORAGE_KEY = SW_CUSTOMER_ID ? 'sw_wl_' + SW_CUSTOMER_ID : null;

  // ── Storage helpers ──
  function getList() {
    if (!SW_STORAGE_KEY) return [];
    try { return JSON.parse(localStorage.getItem(SW_STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }

  function saveList(list) {
    if (!SW_STORAGE_KEY) return;
    localStorage.setItem(SW_STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(productId) {
    return getList().some(function(item) { return String(item.id) === String(productId); });
  }

  function addItem(data) {
    var list = getList();
    if (!isWishlisted(data.id)) {
      list.unshift({ id: String(data.id), title: data.title, price: data.price, image: data.image, handle: data.handle, variant_id: data.variant_id, type: data.product_type, added_at: Date.now() });
      saveList(list);
      firePixelEvent(data);
    }
  }

  function removeItem(productId) {
    saveList(getList().filter(function(item) { return String(item.id) !== String(productId); }));
  }

  // ── Pixel / Analytics ──
  function firePixelEvent(data) {
    var priceNum = data.price ? (data.price / 100) : 0;
    // GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: 'USD',
        value: priceNum,
        items: [{ item_id: String(data.id), item_name: data.title, item_category: data.product_type || '', price: priceNum, quantity: 1 }]
      }
    });
    // Meta Pixel (if present)
    if (typeof fbq === 'function') {
      fbq('track', 'AddToWishlist', { content_ids: [String(data.id)], content_name: data.title, content_type: 'product', value: priceNum, currency: 'USD' });
    }
  }

  // ── Button state ──
  function updateButton(btn, wishlisted) {
    btn.classList.toggle('sw-wl-btn--active', wishlisted);
    btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
    btn.setAttribute('title', wishlisted ? 'Saved to wishlist' : 'Save to wishlist');
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-sw-wl-btn]').forEach(function(btn) {
      var pid = btn.getAttribute('data-product-id');
      if (pid) updateButton(btn, isWishlisted(pid));
    });
    updateWishlistCount();
  }

  function updateWishlistCount() {
    var count = getList().length;
    document.querySelectorAll('[data-sw-wl-count]').forEach(function(el) {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  // ── Modal ──
  var modal = document.getElementById('sw-wl-modal');
  function openModal() {
    modal.classList.add('sw-wl--open');
    requestAnimationFrame(function() { requestAnimationFrame(function() { modal.classList.add('sw-wl--visible'); }); });
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('sw-wl--visible');
    setTimeout(function() { modal.classList.remove('sw-wl--open'); document.body.style.overflow = ''; }, 350);
  }
  document.getElementById('sw-wl-modal-close').addEventListener('click', closeModal);
  document.getElementById('sw-wl-modal-x').addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('sw-wl--open')) closeModal(); });

  // ── Main toggle handler ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-sw-wl-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (!SW_LOGGED_IN) { openModal(); return; }

    var pid = btn.getAttribute('data-product-id');
    if (!pid) return;

    if (isWishlisted(pid)) {
      removeItem(pid);
      btn.classList.remove('sw-wl-btn--active');
      btn.classList.add('sw-wl-btn--pop');
      btn.setAttribute('aria-label', 'Add to wishlist');
    } else {
      addItem({
        id: pid,
        title: btn.getAttribute('data-product-title') || '',
        price: parseInt(btn.getAttribute('data-product-price') || 0),
        image: btn.getAttribute('data-product-image') || '',
        handle: btn.getAttribute('data-product-handle') || '',
        variant_id: btn.getAttribute('data-variant-id') || '',
        product_type: btn.getAttribute('data-product-type') || ''
      });
      btn.classList.add('sw-wl-btn--active', 'sw-wl-btn--pop');
      btn.setAttribute('aria-label', 'Remove from wishlist');
    }

    btn.addEventListener('animationend', function() { btn.classList.remove('sw-wl-btn--pop'); }, { once: true });
    updateWishlistCount();
  });

  // ── Init ──
  function init() {
    if (SW_LOGGED_IN) updateAllButtons();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  // Expose globally so the wishlist page + PDP buttons can call it
  window.SWWishlist = { getList: getList, isWishlisted: isWishlisted, updateAllButtons: updateAllButtons, loggedIn: SW_LOGGED_IN };
})();
